const baseURL = 'https://metrotemu.com';

export default baseURL;
